import React, { useCallback } from 'react';
import classnames from 'classnames';

const DEFAULT_PROPS = {
  cases: [],
  chooseCase: (caseDetail: CMxAPI.CaseRun) => {}
};

const CLINICAL_ID_TYPES = {
  ACCESSION_NUMBER: 'Accession'
};

const CaseChooser = (passed: Accelerate.CaseChooserProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...passed
  };
  const { chooseCase, launchParams } = props;

  const handleItemClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      const target =
        (event.target as HTMLDivElement) || document.createElement('div');
      const linkable = target?.closest('a');
      if (!linkable) return;

      const item = linkable.attributes.getNamedItem('data-process-instance-id');
      if (!item) return;

      const processInstanceId = parseInt(item.value);
      if (processInstanceId === undefined) return;

      const caseRun = cases.find(
        caseRun => caseRun.process_instance_id === processInstanceId
      );

      if (caseRun) {
        chooseCase(caseRun);
      }
    },
    [chooseCase]
  );

  const { cases } = passed;
  const hasCases = cases.length > 0;
  const displayedCases = cases.map((caseRun, idx) => {
    const { primary_clinical_identifier: clinicalId } = caseRun;
    return (
      <a
        key={idx}
        data-process-instance-id={caseRun.process_instance_id}
        className={'case-chooser-item qa-case-chooser-item'}
        onClick={handleItemClick}>
        <div className="chase-chooser-description">
          {caseRun.reason_for_visit}
        </div>
        <div className="case-chooser-meta">
          <div className="case-chooser-key">
            {CLINICAL_ID_TYPES[clinicalId.type] || clinicalId.type}:
          </div>
          <div className="case-chooser-value">
            #{clinicalId.number} ({clinicalId.issuer}){' '}
          </div>
        </div>
      </a>
    );
  });

  const classNames = classnames([
    `case-chooser`,
    {
      'case-chooser-empty': !hasCases,
      'case-chooser-populated': hasCases
    }
  ]);

  const dateOfService = launchParams.serviceDate || 'N/A';

  return (
    <div className={classnames(classNames)}>
      <div className="empty-message">No cases were found</div>

      <div className="case-display-container">
        <h4>Select Charge Session</h4>
        <p>
          Multiple results were found for <b>{dateOfService}</b>. Please select
          the relevant item below.
        </p>
        <div>{displayedCases}</div>
      </div>
    </div>
  );
};

export { CaseChooser };
